import {
  ResponsiveContainer,
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts'

interface Props<T extends Record<string, unknown>> {
  dati: T[]
  chiaveX: keyof T
  chiaveY: keyof T
  colore?: string
  altezza?: number
}

export function BarChart<T extends Record<string, unknown>>({
  dati,
  chiaveX,
  chiaveY,
  colore,
  altezza = 220,
}: Props<T>) {
  const tinta = colore ?? leggi('--accent', '#6C47FF')
  const griglia = leggi('--border', '#E4E4EB')
  const testoSec = leggi('--text-secondary', '#6B6B80')
  const surface = leggi('--surface', '#fff')

  return (
    <ResponsiveContainer width="100%" height={altezza}>
      <RechartsBarChart data={dati} margin={{ top: 8, right: 12, bottom: 0, left: -10 }}>
        <CartesianGrid stroke={griglia} strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey={chiaveX as string}
          stroke={testoSec}
          fontSize={11}
          tickLine={false}
          axisLine={{ stroke: griglia }}
        />
        <YAxis stroke={testoSec} fontSize={11} tickLine={false} axisLine={false} />
        <Tooltip
          contentStyle={{
            background: surface,
            border: `1px solid ${griglia}`,
            borderRadius: 8,
            fontSize: 13,
          }}
        />
        <Bar dataKey={chiaveY as string} fill={tinta} radius={[6, 6, 0, 0]} />
      </RechartsBarChart>
    </ResponsiveContainer>
  )
}

function leggi(nome: string, fb: string): string {
  if (typeof window === 'undefined') return fb
  return getComputedStyle(document.documentElement).getPropertyValue(nome).trim() || fb
}
